"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultInterface = createDefaultInterface;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createDefaultInterface(prefix) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = {},
      accessToken,
      historyId,
      userAgent,
      referrer;
  var config = options.config;
  var version = config["SPM_".concat(prefix, "_API_VERSION")];
  var apiKey = config["SPM_".concat(prefix, "_API_KEY")];
  var baseUrl = config["SPM_".concat(prefix, "_API_HOST")];
  var serviceId = config["SPM_SERVICE_ID"] || '';

  if (config.SSR === true) {
    var req = options.req;
    historyId = options.historyId || '';
    if (req.cookies && req.cookies.sm_at) accessToken = req.cookies.sm_at;
    userAgent = req.headers['user-agent'];
    referrer = req.headers.referrer;
  } else {
    accessToken = _jsCookie["default"].get('sm_at');
    userAgent = window.navigator.userAgent;
    referrer = document.referrer;
    historyId = _jsCookie["default"].get('history_id') || '';
  }

  if (accessToken) headers['Authorization'] = "Bearer ".concat(accessToken);
  headers = Object.assign(headers, {
    'Accept-Language': 'ja-jp',
    'Spacemarket-Version': version,
    'x-api-key': apiKey,
    'Spacemarket-Service-ID': serviceId,
    'Spacemarket-Forwarded-History-Id': historyId,
    'Spacemarket-Forwarded-Referer': referrer || '',
    'Spacemarket-Forwarded-User-Agent': userAgent
  });
  return {
    headers: headers,
    baseUrl: baseUrl
  };
}